import { CompanyWithCollaboratives } from "../../../types/company/company";
import { CompanyWithCollaborativesDto } from "../../../types/company/company-dto";

export const convertCompanyWithCollaborativesDtoToCompanyWithCollaboratives = (
  companyWithCollaborativesDto: CompanyWithCollaborativesDto
): CompanyWithCollaboratives => {
  return {
    id: companyWithCollaborativesDto.id,
    name: companyWithCollaborativesDto.name,
    phone: companyWithCollaborativesDto.phone,
    clients: companyWithCollaborativesDto.clients,
    agencies: companyWithCollaborativesDto.agencies,
    status: companyWithCollaborativesDto.status,
    roles: companyWithCollaborativesDto.roles ?? [],
  };
};
